import { render, staticRenderFns } from "./bookerAcademy.vue?vue&type=template&id=34b7b99e"
import script from "./bookerAcademy.vue?vue&type=script&lang=js"
export * from "./bookerAcademy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports